import { ActionHandler, ActionHandlerParams } from "..";
import {
  MedEligibilityCheckpoint,
  trackMedEligibilityCheckpoint,
} from "src/utils/medEligibilityTracking";

type Params = {
  checkpoint: MedEligibilityCheckpoint;
};

export const trackMedEligibility: ActionHandler = (
  actionParams: {
    params: Params;
  } & ActionHandlerParams
): void => {
  const checkpoint = actionParams?.params?.checkpoint;
  if (checkpoint) {
    trackMedEligibilityCheckpoint(checkpoint);
  }
};
